'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />
/* tslint:disable:no-unused-variable member-ordering */
var API;
(function (API) {
    var Client;
    (function (Client) {
        'use strict';

        var AddressApi = function () {
            function AddressApi($http, $httpParamSerializer, basePath) {
                _classCallCheck(this, AddressApi);

                this.$http = $http;
                this.$httpParamSerializer = $httpParamSerializer;
                this.basePath = '/proxy/oag/gwt-commons/AddressesRestService';
                this.defaultHeaders = {};
                if (basePath) {
                    this.basePath = basePath;
                }
            }

            _createClass(AddressApi, [{
                key: 'extendObj',
                value: function extendObj(objA, objB) {
                    for (var key in objB) {
                        if (objB.hasOwnProperty(key)) {
                            objA[key] = objB[key];
                        }
                    }
                    return objA;
                }
                /**
                 * List of States
                 * Busca de estados\n
                 * @param countryCode Country code
                 */

            }, {
                key: 'addressesCountriesCountryCodeStatesGet',
                value: function addressesCountriesCountryCodeStatesGet(countryCode, extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/addresses/countries/{countryCode}/states'.replace('{' + 'countryCode' + '}', String(countryCode));
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    // verify required parameter 'countryCode' is set
                    if (!countryCode) {
                        throw new Error('Missing required parameter countryCode when calling addressesCountriesCountryCodeStatesGet');
                    }
                    var httpRequestParams = {
                        method: 'GET',
                        url: localVarPath,
                        json: true,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
                /**
                 * List of cities
                 * Busca de paises\n
                 * @param countryCode c\u00F3digo de pais para busca
                 * @param stateCode c\u00F3digo do estado para busca
                 */

            }, {
                key: 'addressesCountriesCountryCodeStatesStateCodeCitiesGet',
                value: function addressesCountriesCountryCodeStatesStateCodeCitiesGet(countryCode, stateCode, extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/addresses/countries/{countryCode}/states/{stateCode}/cities'.replace('{' + 'countryCode' + '}', String(countryCode)).replace('{' + 'stateCode' + '}', String(stateCode));
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    // verify required parameter 'countryCode' is set
                    if (!countryCode) {
                        throw new Error('Missing required parameter countryCode when calling addressesCountriesCountryCodeStatesStateCodeCitiesGet');
                    }
                    // verify required parameter 'stateCode' is set
                    if (!stateCode) {
                        throw new Error('Missing required parameter stateCode when calling addressesCountriesCountryCodeStatesStateCodeCitiesGet');
                    }
                    var httpRequestParams = {
                        method: 'GET',
                        url: localVarPath,
                        json: true,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
                /**
                 * List of Countries
                 * Returns all countries\n
                 */

            }, {
                key: 'addressesCountriesGet',
                value: function addressesCountriesGet(extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/addresses/countries';
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    var httpRequestParams = {
                        method: 'GET',
                        url: localVarPath,
                        json: true,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
                /**
                 * Returns a list of addresses based on request
                 * Returns de endere\u00E7o por CEP\n
                 * @param cep CEP do endere\u00E7o de busca
                 */

            }, {
                key: 'addressesGet',
                value: function addressesGet(cep, extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/addresses';
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    // verify required parameter 'cep' is set
                    if (!cep) {
                        throw new Error('Missing required parameter cep when calling addressesGet');
                    }
                    if (cep !== undefined) {
                        queryParameters['cep'] = cep;
                    }
                    var httpRequestParams = {
                        method: 'GET',
                        url: localVarPath,
                        json: true,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
            }]);

            return AddressApi;
        }();

        AddressApi.$inject = ['$http', '$httpParamSerializer'];
        Client.AddressApi = AddressApi;
    })(Client = API.Client || (API.Client = {}));
})(API || (API = {}));